export default "__VITE_ASSET__omamTftP__"